import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 90000 });

export const slugify = (t) =>
  t.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

// Clean up verbose AI product names for display (non-destructive — original stays in DB)
export const displayName = (name = "", max = 40) => {
  let n = String(name).trim();
  // Drop qualifier parentheticals like "(assumed: ...)", "(Generic)", "(approx.)"
  n = n.replace(/\s*\((?:assumed|generic|approx|estimated|guess|probably|likely)[^)]*\)/gi, "");
  // Drop any remaining trailing "(...)" segment
  n = n.replace(/\s*\([^)]*\)\s*$/g, "").trim();
  if (n.length > max) {
    const cut = n.slice(0, max);
    const sp = cut.lastIndexOf(" ");
    n = (sp > 18 ? cut.slice(0, sp) : cut).trim() + "…";
  }
  return n || String(name).trim();
};

export const searchProducts = async (q) => {
  const { data } = await api.get(`/search`, { params: { q } });
  return data.suggestions || [];
};

export const analyzeProduct = async (productName, force = false) => {
  const { data } = await api.post(`/analyze`, { productName, force });
  return data;
};

export const getProduct = async (slug) => {
  const { data } = await api.get(`/product/${slug}`);
  return data;
};

export const getPreloaded = async () => {
  const { data } = await api.get(`/preloaded`);
  return data.products || [];
};

export const getTrending = async () => {
  const { data } = await api.get(`/trending`);
  return data;
};

export const compareProducts = async (product1, product2) => {
  const { data } = await api.post(`/compare`, { product1, product2 });
  return data;
};

export const getIngredients = async () => {
  const { data } = await api.get(`/ingredients`);
  return data;
};

export const getIngredient = async (slug) => {
  const { data } = await api.get(`/ingredient/${slug}`);
  return data;
};

export const getCategories = async () => {
  const { data } = await api.get(`/categories`);
  return data.categories || [];
};

export const getCategory = async (slug) => {
  const { data } = await api.get(`/category/${slug}`);
  return data;
};

export const getTrendingIngredients = async () => {
  const { data } = await api.get(`/ingredients/trending`);
  return data.ingredients || [];
};
